// API
import api from 'src/services/@core/API'

export const getPatients = (filters) => () => {
  const config = { query: filters }

  return api.getPatients(config)
}

export const createPatient = (payload) => () => api.postPatient(payload)
